import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useShortsFilterChangeStore = defineStore(
	'shortsFilterChange',
	() => {
		const changedKeys = ref<Set<string>>(new Set());

		function addChangedKey(key: string) {
			changedKeys.value.add(key);
		}

		function addChangedKeys(keys: string[]) {
			keys.forEach(key => changedKeys.value.add(key));
		}

		function clear() {
			changedKeys.value.clear();
		}

		function hasChanges() {
			return changedKeys.value.size > 0;
		}

		function getChangedKeys() {
			return Array.from(changedKeys.value);
		}

		return {
			changedKeys,
			addChangedKey,
			addChangedKeys,
			clear,
			hasChanges,
			getChangedKeys
		};
	}
);
